<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <h1 class="headline font-weight-light mb-3">
                    Dashboards
                </h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        KPI Monitor

                        <v-spacer></v-spacer>

                        <v-btn icon @click="show = !show">
                            <v-icon>{{
                                show ? "mdi-chevron-up" : "mdi-chevron-down"
                            }}</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-subtitle>
                        <v-row>
                            <v-col cols="12" sm="5" md="3">
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="dateRangeText"
                                            label="Select Date"
                                            readonly
                                            v-on="on"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dates"
                                        range
                                        @change="get_date()"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="5" md="3">
                                <v-autocomplete
                                    chips
                                    outlined
                                    dense
                                    v-model="selectedFruits"
                                    :items="fruits"
                                    label="Select Project"
                                    multiple
                                >
                                    <template
                                        v-slot:selection="{
                                            item,
                                            index,
                                        }"
                                    >
                                        <v-chip small v-if="index === 0">
                                            <span>{{ item }}</span>
                                        </v-chip>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                            >(+{{
                                                selectedFruits.length - 1
                                            }}
                                            others)</span
                                        >
                                    </template>
                                    <template v-slot:prepend-item>
                                        <v-list-item ripple @click="toggle">
                                            <v-list-item-action>
                                                <v-icon
                                                    :color="
                                                        selectedFruits.length >
                                                        0
                                                            ? 'indigo darken-4'
                                                            : ''
                                                    "
                                                >
                                                    {{ icon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    Select All
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                    <template v-slot:append-item>
                                        <v-divider class="mb-2"></v-divider>
                                        <v-list-item disabled>
                                            <v-list-item-avatar
                                                color="grey lighten-3"
                                            >
                                                <v-icon>
                                                    mdi-star-circle
                                                </v-icon>
                                            </v-list-item-avatar>

                                            <v-list-item-content
                                                v-if="likesAllFruit"
                                            >
                                                <v-list-item-title>
                                                    All Project
                                                </v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-content
                                                v-else-if="likesSomeFruit"
                                            >
                                                <v-list-item-title>
                                                    Project Count
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ selectedFruits.length }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>

                                            <v-list-item-content v-else>
                                                <v-list-item-title>
                                                    Project
                                                </v-list-item-title>
                                                <!-- <v-list-item-subtitle>
                                                    Go ahead, make a selection
                                                    above!
                                                </v-list-item-subtitle> -->
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-autocomplete>
                                <!-- xx -->
                            </v-col>
                            <v-col cols="1">
                                <v-btn
                                    x-small
                                    fab
                                    :color="
                                        chk == false
                                            ? 'green accent-2'
                                            : 'amber'
                                    "
                                    @click="get_data()"
                                    :disabled="
                                        dates.length == 0 ||
                                            selectedFruits.length == 0
                                    "
                                    ><v-icon>mdi-arrow-right</v-icon></v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-expand-transition>
                        <div v-show="show">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th
                                                        class="text-center"
                                                        rowspan="2"
                                                    >
                                                        Zone
                                                    </th>
                                                    <th
                                                        class="text-center"
                                                        colspan="2"
                                                    >
                                                        SLA
                                                    </th>
                                                    <th
                                                        class="text-center"
                                                        colspan="3"
                                                    >
                                                        Cases
                                                    </th>
                                                    <th
                                                        class="text-center"
                                                        colspan="3"
                                                    >
                                                        Pending
                                                    </th>
                                                </tr>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        4 hr.
                                                    </th>
                                                    <th class="text-center">
                                                        4 hr. Up
                                                    </th>
                                                    <th class="text-center">
                                                        Total
                                                    </th>
                                                    <th class="text-center">
                                                        Miss
                                                    </th>
                                                    <th class="text-center">
                                                        Pass
                                                    </th>
                                                    <th class="text-center">
                                                        Total
                                                    </th>
                                                    <th class="text-center">
                                                        Miss
                                                    </th>
                                                    <th class="text-center">
                                                        In SLA
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(r, i) in data_main"
                                                    :key="i"
                                                >
                                                    <td>{{ r.zone }}</td>
                                                    <td class="text-right">
                                                        {{ r.sla1 }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.sla2 }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.total }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.miss }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.pass }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.total_pending }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.miss_pending }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ r.in_pending }}
                                                    </td>
                                                </tr>
                                                <br />
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios"
const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    computed: {
        likesAllFruit() {
            return this.selectedFruits.length === this.fruits.length
        },
        likesSomeFruit() {
            return this.selectedFruits.length > 0 && !this.likesAllFruit
        },
        icon() {
            if (this.likesAllFruit) return "mdi-close-box"
            if (this.likesSomeFruit) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },
        dateRangeText() {
            this.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.dates.join(" ~ ")
        },
    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                if (this.likesAllFruit) {
                    this.selectedFruits = []
                } else {
                    this.selectedFruits = this.fruits.slice()
                }
            })
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.menu2 = false
            }
        },
        async get_data() {
            this.chk = true
            await axios.post(url + "kpi-monitor").then((response) => {
                this.show = true
                this.chk = false
                this.data_main = response.data
            })
        },
    },
    data() {
        return {
            show: false,
            fruits: ["Project A", "Project B", "Project C", "Project D"],
            selectedFruits: [],
            menu2: false,
            dates: [],
            chk: false,
            data_main: [],
        }
    },
}
</script>
